// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Row$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as InsuranceAssetsManager from "../assets/InsuranceAssetsManager.bs.js";

var warningIcon = InsuranceAssetsManager.getImage("warning-icon.svg");

function InsuranceEligibilityRequirementCmp(Props) {
  var text = Props.text;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "insurance-eligibility-requirement-card-container"
            }, React.createElement("img", {
                  className: "red-warn-icon",
                  alt: "warning-icon",
                  src: warningIcon
                }), React.createElement("div", {
                  className: "insurance-eligible-condition"
                }, text));
}

var make = InsuranceEligibilityRequirementCmp;

export {
  warningIcon ,
  make ,
  
}
/* warningIcon Not a pure module */
